import { useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { TrashBinOutline } from "react-ionicons";
import Api from "../../utils/api";
import ButtonSave from "../components/ButtonSave";

const SourceOutput = ({ item, sourceId, profiles, onUpdates, onDelete }) => {

    const [output, setOutput] = useState(item);
    const [buttonStatus, setButtonStatus] = useState(0);
    const [showModalDelete, setShowModalDelete] = useState(false);

    const save = async () => {
        setButtonStatus(2)
        const result = await Api.post('/streams/' + sourceId + '/output/' + output.id, output);

        if (output.id === 0) {
            setOutput((state) => ({
                ...state,
                'id': parseInt(result.data),
            }));

        }
        onUpdates(output)
        setButtonStatus(3)
    };


    const updateOutput = (event) => {
        let { name, value } = event.target;

        if (name === 'isBackup' || name === 'status') {
            //value = value === '1' ? true : false
            //value = value ? '1' : '2';
        }

        setOutput((state) => ({
            ...state,
            [name]: value,
        }));

        setButtonStatus(1)
    };

    const handleDelete = () => {
        if (item) {
            Api.delete('/streams/' + sourceId + '/output/' + item.id)
        }
        onDelete()
    };

    return (

        <>

            <Modal show={showModalDelete}>
                <Modal.Header>Eliminar salida</Modal.Header>
                <Modal.Body>Confirma que desea eliminar esta salida?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowModalDelete(false) }}>
                        Cancelar
                    </Button>

                    <Button variant="primary" onClick={() => { setShowModalDelete(false); handleDelete() }}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>


            <Card className="mt-4">
                <Card.Header>
                    <Row className="justify-content-between">
                        <Col>
                            Salida #{output && output.id}
                        </Col>

                        <Col className="text-end" title="Eliminar">
                            <TrashBinOutline color={'#fff'} style={{ cursor: 'pointer' }} onClick={() => setShowModalDelete(true)} />
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control name="name" defaultValue={output ? output.name : ''} onChange={updateOutput} />
                        </Col>
                        <Col>
                            <Form.Label>Map</Form.Label>
                            <Form.Control name="map" defaultValue={output ? output.map : ''} onChange={updateOutput} />
                        </Col>
                    </Row>


                    <Row className="mt-3">
                        <Col>
                            <Form.Group>
                                <Form.Label>Perfil {output ? output.profileId : ''}</Form.Label>
                                <Form.Select name="profileId" defaultValue={output ? output.profileId : ''} onChange={updateOutput}>
                                    {profiles.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Es Respaldo</Form.Label>
                                <Form.Select name="isBackup" defaultValue={output && output.isBackup ? '1' : '0'} onChange={updateOutput}>
                                    <option value="0">No</option>
                                    <option value="1">Si</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Estado</Form.Label>
                                {console.log(output)}
                                {/*<Form.Select name="status" value={!output && !output.status ? '0' : '1'} onChange={updateOutput}>*/}
                                <Form.Select name="status" value={output.status} onChange={updateOutput}>
                                    <option value={false}>Inactivo</option>
                                    <option value={true}>Activo</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="text-end mt-3">
                        <ButtonSave onClick={save} status={buttonStatus} setStatus={setButtonStatus} />
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default SourceOutput;